var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card3d"},[_c('div',{ref:"scene",staticClass:"card3d__scene"})])
}
var staticRenderFns = []

export { render, staticRenderFns }